export interface DropDownItem {
  to: string
  title: string
  text?: string
}

export interface ResourceDropDownItem {
  to: string
  title: string
  subtitle: string
  featured: boolean
  links: { title: string; url: string }[]
}

export const platformDropDownContent: DropDownItem[] = [
  {
    to: '/user-research-repository',
    title: 'Build a User Research Repository',
    text: 'Store all research in a single, organized research repository',
  },
  {
    to: '/user-research-synthesis-and-analysis',
    title: 'Analyze Research Data',
    text: 'Organize notes, tag data, find patterns and themes',
  },
  {
    to: '/user-research-insights-and-nuggets',
    title: 'Create Key Insights & Reports',
    text: 'Build better products with clear research insights',
  },
]

export const solutionsDropDownContent: DropDownItem[] = [
  {
    to: '/solutions/ux-research-operations',
    title: 'Research Operations',
  },
  {
    to: '/solutions/ux-research',
    title: 'UX Researchers',
  },
  {
    to: '/solutions/ux-design',
    title: 'UX Designers',
  },
]

export const compareDropDownContent: DropDownItem[] = [
  { to: '/compare/dovetail-alternative', title: 'Aurelius vs Dovetail' },
  { to: '/compare/EnjoyHQ-alternative', title: 'Aurelius vs EnjoyHQ' },
  { to: '/compare/Airtable-alternative', title: 'Aurelius vs Airtable' },
  { to: '/compare/Confluence-alternative', title: 'Aurelius vs Confluence' },
  {
    to: '/compare/spreadsheets-alternative',
    title: 'Aurelius vs Spreadsheets',
  },
  { to: '/compare/Google-Docs-alternative', title: 'Aurelius vs Google Docs' },
]

export const resourcesDropDownContent: ResourceDropDownItem[] = [
  {
    to: `${process.env.BLOG_URL}`,
    title: 'Blog',
    subtitle: 'Articles on UX research, design and building products',
    featured: true,
    links: [
      {
        title: 'How Does Aurelius Improve UX Research for Product Teams?',
        url: '/how-aurelius-improves-ux-research-for-product-teams',
      },
      {
        title:
          'User Research: How to Collect, Organize & Share Qualitative Data',
        url: '/user-research-qualitative-data',
      },
    ],
  },
  {
    to: `${process.env.BLOG_URL}/tag/podcast`,
    title: 'Podcast',
    subtitle:
      'Hear from industy experts on all things UX, research and product',
    featured: false,
    links: [
      {
        title: 'How to Organize Qualitative Research: A Step-by-Step Guide',
        url: '/how-to-organize-qualitative-research',
      },
      {
        title: 'The Complete Guide to Conducting UX Research Interviews',
        url: '/ux-user-research-interview-guide',
      },
    ],
  },
]
